export function hasQuickBooksInvoiceId(value: unknown): boolean {
  if (typeof value === "number") {
    return value > 0;
  }

  if (typeof value === "string") {
    const normalized = value.trim();
    return normalized !== "" && normalized !== "0";
  }

  return false;
}
